import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
// 3rd party imports
import notify from 'devextreme/ui/notify';
// CC-Common imports
import { Utils } from 'cc-common';
// Service imports
import { CommunityService } from '../_services/data-services/community.service';
// Constant imports
import { MessageInterval } from '../_constants/messages-intervals';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../_services/data-services/community.service";
export class CommunityGuard {
    constructor(router, communityService) {
        this.router = router;
        this.communityService = communityService;
    }
    canActivate(route) {
        const communityId = parseInt(route.params.communityId, 10);
        if (Utils.isNullOrUndefined(this.communityIds)) {
            return this.checkCummunityAccess(communityId);
        }
        else {
            return this.hasCommunityAccess(communityId);
        }
    }
    checkCummunityAccess(communityId) {
        return this.communityService.getCommunities(false, true).pipe(map((communities) => {
            this.communityIds = communities.map((r) => r.communityId);
            return this.hasCommunityAccess(communityId);
        }));
    }
    hasCommunityAccess(communityId) {
        const hasAccess = Utils.isInList(communityId, this.communityIds);
        if (Utils.isFalse(hasAccess)) {
            this.router.navigate(['home']);
            notify('Invalid route. Redirecting to Home', 'error', MessageInterval.defaultErrorMsgInterval);
        }
        return hasAccess;
    }
}
CommunityGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CommunityGuard_Factory() { return new CommunityGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.CommunityService)); }, token: CommunityGuard, providedIn: "root" });
